import styled from 'styled-components/macro'
import { theme, switchProp, ifProp } from 'styled-tools'
import { rem, rgba, color } from '../../utils/styles'

const padding = switchProp('size', {
  s: '.5em 1.5em'
}, '1em 3em')

const colorBase = ifProp('primary', color('white'), color('base'))
const inverseColor = ifProp('primary', color('base'), color('white'))

const Button = styled.button`
  display: inline-block;
  border: ${rem(2)} solid ${rgba('base', 0.3)};
  border-radius: ${rem(5)};
  padding: ${padding};
  background: ${ifProp('primary', color('base'), 'transparent')};
  text-align: center;
  font-weight: ${theme('fontWeights.bold')};
  text-decoration: none;
  transition: border-color 200ms, box-shadow 200ms;
  color: ${colorBase};
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    border-color: ${rgba('base', 1)};
    box-shadow: 0 0 0 ${rem(1)} ${rgba('base', 1)};
  }

  &:active {
    background-color: ${colorBase};
    color: ${inverseColor};
  }
`

export default Button
